/***
*
*   CAMPAIGN
*   Information for user to get help and support
*
**********/

import React, { Fragment } from 'react';
import { List } from 'components/lib';
import Astronauta from '../../../assets/planet_1.svg';
import { Link } from 'react-router-dom';
import './campaign.scss';
import { CampaignEmailUsage } from './email-usage';


export function Campaign(props){

  return (
    <Fragment>

      <header className='header-campaign'>
        <h1 className='subtitle-campaign'>{ 'Hola... Estamos listos para crear tu primera campaña!' }</h1>
      </header>

      <CampaignEmailUsage />

      <div className='campaign-start'>
      <div className='campaign-guide'>

        <h2 style={{ fontWeight: 300 }}>
          Para crear tu primera campaña te invitamos a seguir estos pasos:
        </h2>

      <div style={{marginLeft: '30px'}}>
        <List items={[
          'Define tu segmento',
          'Crea el espacio',
          'Completa los requerimientos',
          'Envía y listo!'
        ]}/>
      </div>
      
      <Link to="/creation" className='button-campaign' onClick={() => console.log('test')}><div className='button-div'>Crear Campaña</div></Link>
      </div>
      <div className='logo-campaign'>
        <img width={400} height={500} src={ Astronauta } alt='' />
      </div>
      </div>
      
    </Fragment>
  )
}
